import React, { useState } from "react";
import classNames from "classnames/bind";
import { Link, useParams } from "react-router-dom";
import {
    Col,
    Row,

} from "../../../../components";
import styles from "./AddCamera.module.css";
import { Previous } from "../../../../components/Icons/Icons";
import axiosClient from "../../../../services/axiosClient";
import ModalSetting from "../../Camera/ModalSetting";
import SideBarInfo from "../SideBarInfo";
import ListCamera from "../ListCamera";
import ModalMoreInfo from "../../Camera/ModalMoreDetail";

const cx = classNames.bind(styles);
const CreateWareHouse = () => {
    const [infoCamera, setInfoCamera] = useState([])
    const [showSettingModal, setShowSettingModal] = useState(false)
    const [showModalListCamera, setShowModalListCamera] = useState(false)
    const [showModalMore, setShowModalMore] = useState(false)
    const [dataMore, setDataMore] = useState({ data: [], type: '' })
    const params = useParams()

    const handleClickSetting = async (code) => {
        const res = await axiosClient.get(`cameraManagement/get-camera-info-by-code/?camera_code=${code}`)
        setInfoCamera(res)
        setShowSettingModal(!showSettingModal)
    }

    const handleCloseSetting = () => {
        setShowSettingModal(!showSettingModal)
    }

    const handleShowListCamera = () => {
        setShowModalListCamera(!showModalListCamera)
    }

    const getDataShowMore = (data, type) => {
        setShowModalMore(!showModalMore)
        setDataMore({ data: data, type: type })
    }

    return (
        <div>
            <div className={cx("header")}>
                <Link style={{ textDecoration: "none" }} to="/admin/warehouse">
                    <span className={cx("icon")}>
                        <Previous />
                    </span>
                </Link>
                {params.id ?
                    <h1 className={cx("title")}>Sửa thông tin kho</h1> :
                    <h1 className={cx("title")}>Thêm mới kho</h1>
                }
            </div>
            <div className={cx("content")}>
                <div className={cx('header-label')}>
                    <div className={cx('title-label', 'info')}>Thông tin chung</div>
                    <div className={cx('title-label', 'camera')}>Camera</div>
                </div>
                <Row gap={[0, 16]}>
                    <Col span={4}
                        style={{
                            borderRight: `1px solid rgba(0, 0, 0, 0.05)`,
                            paddingRight: `16px`,
                            maxHeight: `70vh`,
                            overflow: 'auto',
                        }}>
                        <SideBarInfo />
                    </Col>
                    <ListCamera onClickSetting={handleClickSetting} showListCamera={handleShowListCamera} showModalMore={(data, type) => getDataShowMore(data, type)} />
                </Row>
            </div>
            {
                showSettingModal &&
                <ModalSetting
                    camera={infoCamera}
                    onclose={handleCloseSetting}
                    show={showSettingModal}
                />
            }
            {showModalMore && <ModalMoreInfo showModal={getDataShowMore} data={dataMore} />}
        </div>
    );
};
export default CreateWareHouse;
